import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { 
    CircleCheck,
    Clock,
    Mail,
    Plus
 } from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import PopupButton from "components/button/PopupButton";
import MessageTicket from "./components/MessageTicket";
import EmployeeInboxTabs from "./components/InboxTab";
import DepartmentGridCard from "./components/DepartmentCardGrid";
import {
    getTicketList 
} from "../../../../../redux/supportticket/supportticketState";
import {
    getDepartmentList
} from "../../../../../redux/optionlist/optionlistState";

const EmployeeInbox = ({
    doSearch,
    pagination,
    recordList = [],
    getDepartment,
    departmentList
}) => {
    const [selectedDepartment, setSelectedDepartment] = useState("All");

    const getStatusDisplay = (status) => ({
        "Open": "pending",
        "In Progress": "responded",
        "Resolved": "resolved"
    }[status] || "pending");

    const messages = (recordList || []).map(ticket => ({
        id: ticket.tic_id, 
        department: ticket.department,
        initial: ticket.department_initial,
        title: ticket.tic_title,
        status: getStatusDisplay(ticket.ticket_status),
        priority: ticket.ticket_priority?.toLowerCase(),
        time: ticket.created_time,
        date: ticket.created_date_at,
        messagePreview: ticket.tic_description?.substring(0, 80) + "...",
        fullMessage: ticket.tic_description,
        createdBy: ticket.created_by,
        submitted_by: ticket.submitted_by,
        priorityId: ticket.tic_priority_id,
        deptId: ticket.tic_department_id,
        titleId: ticket.tic_title_id,
        categoryId: ticket.tic_category_id,
    }));

    const total = messages.length;
    const pending = messages.filter(m => m.status === "pending").length;
    const resolved = messages.filter(m => m.status === "resolved").length;

    useEffect(() => {
        doSearch({
            paginate: pagination.per_page,
        });
    }, [doSearch, pagination.per_page]);

    useEffect(() => {
        getDepartment();
      }, [getDepartment]);

    return (
        <div className="grid grid-cols-1">
            <div className="space-y-6 max-w-[1800px]">
                <SummaryHeader
                    title={"My Inbox"}
                    icon={Mail}
                    description={"Connect with Hyvid departments for support and assistance"}
                    color={"bg-emerald"}
                    rightNav={
                        <PopupButton 
                            id="add_ticket" 
                            title="Contact Hyvid Department"
                            description="Send a message to any Hyvid department for support and assistance"
                            label="New Message" 
                            btnClass="ticket btn-ticket white" 
                            action="add"
                            moduleId={0}
                            icon={Plus}
                            useCustomClass={true}
                            modalWidth={500}
                        >
                            <MessageTicket recordId="0" mode="edit"/>
                        </PopupButton>
                    }
                >
                   <div className="summary-item-container">
                        <SummaryItem
                            title="Total Messages"
                            icon={<Mail />}
                            display={total}
                        />
                        <SummaryItem
                            title="Pending"
                            icon={<Clock />}
                            display={pending} 
                        />
                        <SummaryItem
                            title="Resolved"
                            icon={<CircleCheck />}
                            display={resolved}
                        />
                   </div>
                </SummaryHeader>
                <DepartmentGridCard 
                    messages={messages}
                    selectedDepartment={selectedDepartment}
                    onSelectDepartment={setSelectedDepartment}
                    departmentOptions={departmentList}
                />
                <EmployeeInboxTabs 
                    messages={messages}
                    selectedDepartment={selectedDepartment}
                />
            </div>
        </div>
    )
};

const mapStateToProps = (state) => ({
    recordList: state.ticket.ticketList?.items,
    pagination: state.ticket.ticketList?.pagination,
    filters: state.ticket.ticketList?.filters,
    departmentList: state.optionlist.departmentList?.items,
});

const mapDispatchToProps = (dispatch) => ({
    doSearch: (filters) => dispatch(getTicketList(filters)),
    getDepartment: (data) => dispatch(getDepartmentList(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(EmployeeInbox);